import { sensorTypes, PiezoSensor } from '../../components/PowertrainAssetDetails/DetailedInformation/OperationalParametersV2/VibrationFFTV2/constants';
import {
    baseToCustomUOM,
    getMeasurementUnits,
    getMeasurementUnitSymbol
} from 'helpers/unitHelper';
import map from 'lodash/map';


export const handleFFTDataConversion = (response) => {
    if (!response?.dataValues) {
        return response;
    }

    response.magnitudeUnitSymbol = getMeasurementUnitSymbol(response.amplitudeMeasurementUnitGroupID);
    response.frequencyUnitSymbol = getMeasurementUnitSymbol(response.frequencyMeasurementUnitGroupID);

    response.dataValues = map(response.dataValues, (dataValue) => {
        dataValue.sensorAxisDataValues = baseToCustomUOM.convertMeasurementMultiPrecision(
            dataValue.sensorAxisDataValues,
            {
                magnitude: { measurementUnitGroup: response.amplitudeMeasurementUnitGroupID, precision: 4 },
                frequency: { measurementUnitGroup: response.frequencyMeasurementUnitGroupID, precision: response.precision }
            }
        );

        return dataValue;
    });

    return response;
};

export const handleFFTV2DataConversion = (response) => {
    let dataValues = [];
    if (!response?.sensors) {
        return response;
    }
    const userMeasurementUnitGroups = getMeasurementUnits();

    // Get Piezzo sensor type
    const piezzoSensor = response?.sensors?.find(sensor => sensor.sensorType === sensorTypes.PIEZZO);

    // Get Acc sensor type
    const accSensor = response?.sensors?.find(sensor => sensor.sensorType === sensorTypes.ACC);

    dataValues = [
        ...piezzoSensor?.dataValues?.length ? [{
            sensorAxisName: PiezoSensor?.axisName,
            sensorAxisDataValues: piezzoSensor?.dataValues[0]?.sensorAxisDataValues
        }] : [],
        ...accSensor?.dataValues?.length ? [...accSensor.dataValues] : []
    ];

    response.magnitudeUnitSymbol = getMeasurementUnitSymbol(response.amplitudeMeasurementUnitGroupId);
    response.frequencyUnitSymbol = getMeasurementUnitSymbol(response.frequencyMeasurementUnitGroupId);

    response.dataValues = map(dataValues, (dataValue) => {
        dataValue.sensorAxisDataValues = baseToCustomUOM.convertMeasurementMultiPrecision(
            dataValue.sensorAxisDataValues,
            {
                magnitude: { measurementUnitGroup: response.amplitudeMeasurementUnitGroupId, precision: 4 },
                frequency: { measurementUnitGroup: response.frequencyMeasurementUnitGroupId, precision: response.precision }
            }
        );

        dataValue.harmonicsHighestPeaks = dataValue.harmonicsHighestPeaks?.map(peak => {
            const convertedFrequency = baseToCustomUOM.convertAndFormatWithGroups(response.frequencyMeasurementUnitGroupId, peak.frequencyValue, userMeasurementUnitGroups);
            const convertedMagnitude = baseToCustomUOM.convertAndFormatWithGroups(response.amplitudeMeasurementUnitGroupId, peak.magnitude, userMeasurementUnitGroups);
            return {
                ...peak,
                frequencyValue: convertedFrequency?.measurementValue % 1 === 0 ? convertedFrequency?.measurementValue : parseFloat(convertedFrequency?.measurementValue?.toFixed(response.precision)),
                magnitude: convertedMagnitude?.measurementValue % 1 === 0 ? convertedMagnitude?.measurementValue : parseFloat(convertedMagnitude?.measurementValue?.toFixed(4))
            };
        });

        return dataValue;
    });

    response.bearingFaultFrequencies = response.bearingFaultFrequencies?.map(bearing => {
        const convertedValue = baseToCustomUOM.convertAndFormatWithGroups(response.frequencyMeasurementUnitGroupId, bearing.value, userMeasurementUnitGroups);
        const convertedMagnitude = baseToCustomUOM.convertAndFormatWithGroups(response.amplitudeMeasurementUnitGroupId, bearing.magnitude, userMeasurementUnitGroups);
        return {
            ...bearing,
            value: convertedValue?.measurementValue % 1 === 0 ? convertedValue?.measurementValue : parseFloat(convertedValue?.measurementValue?.toFixed(response.precision)),
            magnitude: convertedMagnitude?.measurementValue % 1 === 0 ? convertedMagnitude?.measurementValue : parseFloat(convertedMagnitude?.measurementValue?.toFixed(4))
        };
    });

    response.harmonicsHighestPeaks = response.harmonicsHighestPeaks?.map(peak => {
        const convertedFrequency = baseToCustomUOM.convertAndFormatWithGroups(response.frequencyMeasurementUnitGroupId, peak.frequencyValue, userMeasurementUnitGroups);
        const convertedMagnitude = baseToCustomUOM.convertAndFormatWithGroups(response.amplitudeMeasurementUnitGroupId, peak.magnitude, userMeasurementUnitGroups);
        return {
            ...peak,
            frequencyValue: convertedFrequency?.measurementValue % 1 === 0 ? convertedFrequency?.measurementValue : parseFloat(convertedFrequency?.measurementValue?.toFixed(response.precision)),
            magnitude: convertedMagnitude?.measurementValue % 1 === 0 ? convertedMagnitude?.measurementValue : parseFloat(convertedMagnitude?.measurementValue?.toFixed(4))
        };
    });

    response.harmonics = response.harmonics?.map(harmonic => {
        const convertedValue = baseToCustomUOM.convertAndFormatWithGroups(response.frequencyMeasurementUnitGroupId, harmonic.value, userMeasurementUnitGroups);
        const convertedMagnitude = baseToCustomUOM.convertAndFormatWithGroups(response.amplitudeMeasurementUnitGroupId, harmonic.magnitude, userMeasurementUnitGroups);
        return {
            ...harmonic,
            value: convertedValue?.measurementValue % 1 === 0 ? convertedValue?.measurementValue : parseFloat(convertedValue?.measurementValue?.toFixed(response.precision)),
            magnitude: convertedMagnitude?.measurementValue % 1 === 0 ? convertedMagnitude?.measurementValue : parseFloat(convertedMagnitude?.measurementValue?.toFixed(4))
        };
    });

    return [{ ...response }];
};

export const handleFFTV2DataByTimestampConversion = (data) => {
    return data?.fftsByTimestamp?.map(response => {
        let dataValues = [];
        if (!response?.sensors) {
            return response;
        }
        const userMeasurementUnitGroups = getMeasurementUnits();

        // Get Piezzo sensor type
        const piezzoSensor = response?.sensors?.find(sensor => sensor.sensorType === sensorTypes.PIEZZO);

        // Get Acc sensor type
        const accSensor = response?.sensors?.find(sensor => sensor.sensorType === sensorTypes.ACC);

        dataValues = [
            ...piezzoSensor?.dataValues?.length ? [{
                sensorAxisName: PiezoSensor?.axisName,
                sensorAxisDataValues: piezzoSensor?.dataValues[0]?.sensorAxisDataValues
            }] : [],
            ...accSensor?.dataValues?.length ? [...accSensor.dataValues] : []
        ];

        response.magnitudeUnitSymbol = getMeasurementUnitSymbol(response.amplitudeMeasurementUnitGroupId);
        response.frequencyUnitSymbol = getMeasurementUnitSymbol(data.frequencyMeasurementUnitGroupId);

        response.dataValues = map(dataValues, (dataValue) => {
            dataValue.sensorAxisDataValues = baseToCustomUOM.convertMeasurementMultiPrecision(
                dataValue.sensorAxisDataValues,
                {
                    magnitude: { measurementUnitGroup: response.amplitudeMeasurementUnitGroupId, precision: 4 },
                    frequency: { measurementUnitGroup: data.frequencyMeasurementUnitGroupId, precision: data.precision }
                }
            );

            dataValue.harmonicsHighestPeaks = dataValue.harmonicsHighestPeaks?.map(peak => {
                const convertedFrequency = baseToCustomUOM.convertAndFormatWithGroups(data.frequencyMeasurementUnitGroupId, peak.frequencyValue, userMeasurementUnitGroups);
                const convertedMagnitude = baseToCustomUOM.convertAndFormatWithGroups(response.amplitudeMeasurementUnitGroupId, peak.magnitude, userMeasurementUnitGroups);
                return {
                    ...peak,
                    frequencyValue: convertedFrequency?.measurementValue % 1 === 0 ? convertedFrequency?.measurementValue : parseFloat(convertedFrequency?.measurementValue?.toFixed(data.precision)),
                    magnitude: convertedMagnitude?.measurementValue % 1 === 0 ? convertedMagnitude?.measurementValue : parseFloat(convertedMagnitude?.measurementValue?.toFixed(4))
                };
            });

            return dataValue;
        });

        response.bearingFaultFrequencies = response.bearingFaultFrequencies?.map(bearing => {
            const convertedValue = baseToCustomUOM.convertAndFormatWithGroups(data.frequencyMeasurementUnitGroupId, bearing.value, userMeasurementUnitGroups);
            const convertedMagnitude = baseToCustomUOM.convertAndFormatWithGroups(response.amplitudeMeasurementUnitGroupId, bearing.magnitude, userMeasurementUnitGroups);
            return {
                ...bearing,
                value: convertedValue?.measurementValue % 1 === 0 ? convertedValue?.measurementValue : parseFloat(convertedValue?.measurementValue?.toFixed(data.precision)),
                magnitude: convertedMagnitude?.measurementValue % 1 === 0 ? convertedMagnitude?.measurementValue : parseFloat(convertedMagnitude?.measurementValue?.toFixed(4))
            };
        });

        response.harmonicsHighestPeaks = response.harmonicsHighestPeaks?.map(peak => {
            const convertedFrequency = baseToCustomUOM.convertAndFormatWithGroups(data.frequencyMeasurementUnitGroupId, peak.frequencyValue, userMeasurementUnitGroups);
            const convertedMagnitude = baseToCustomUOM.convertAndFormatWithGroups(response.amplitudeMeasurementUnitGroupId, peak.magnitude, userMeasurementUnitGroups);
            return {
                ...peak,
                frequencyValue: convertedFrequency?.measurementValue % 1 === 0 ? convertedFrequency?.measurementValue : parseFloat(convertedFrequency?.measurementValue?.toFixed(data.precision)),
                magnitude: convertedMagnitude?.measurementValue % 1 === 0 ? convertedMagnitude?.measurementValue : parseFloat(convertedMagnitude?.measurementValue?.toFixed(4))
            };
        });

        response.harmonics = response.harmonics?.map(harmonic => {
            const convertedValue = baseToCustomUOM.convertAndFormatWithGroups(data.frequencyMeasurementUnitGroupId, harmonic.value, userMeasurementUnitGroups);
            const convertedMagnitude = baseToCustomUOM.convertAndFormatWithGroups(response.amplitudeMeasurementUnitGroupId, harmonic.magnitude, userMeasurementUnitGroups);
            return {
                ...harmonic,
                value: convertedValue?.measurementValue % 1 === 0 ? convertedValue?.measurementValue : parseFloat(convertedValue?.measurementValue?.toFixed(data.precision)),
                magnitude: convertedMagnitude?.measurementValue % 1 === 0 ? convertedMagnitude?.measurementValue : parseFloat(convertedMagnitude?.measurementValue?.toFixed(4))
            };
        });

        return response;
    });
};
